import React from 'react';
import PropTypes from 'prop-types';
import LoadingCard from 'components/loading/LoadingCard';
import ProductsShow from './ProductsShow';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import fetchResourceById from 'components/hoc/fetchResourceById';
import { fetchProduct } from 'store/actions/products/fetchProducts';
import { duplicateProductRequest } from 'http/requests/products/productsRequests';

class ProductsShowContainer extends React.Component {
    render() {
        const {
            data,
            history,
            id,
            location,
            resource,
            resourceFetchFailed,
            resourceFetchLoading,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        if (!data) {
            return null;
        }

        const duplicate = () => {
            return duplicateProductRequest(data.id).then((clonedProduct) => {
                history.push(`/products/${ clonedProduct.id }/show`);
            });
        };

        return <ProductsShow
            duplicate={ duplicate }
            history={ history }
            id={ id }
            location={ location }
            record={ data }
            resource={ resource }
        />;
    }
}

ProductsShowContainer.propTypes = {
    data: PropTypes.object,
    history: PropTypes.object.isRequired,
    id: PropTypes.string,
    location: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const fetchValues = {
    resource: 'products',
    action: fetchProduct,
};

export default fetchResourceById(fetchValues)(ProductsShowContainer);



// WEBPACK FOOTER //
// ./src/pages/products/show/ProductsShowContainer.js